import { StatusBadge } from "./StatusBadge";
import type { EvidenceItem } from "./content/evidenceContent";

interface Props extends EvidenceItem {
	className?: string;
}

function calculateStatus(
	startDate?: string,
	endDate?: string,
): "upcoming" | "underway" | "completed" {
	if (!startDate || !endDate) return "completed";
	const now = new Date();
	const start = new Date(startDate);
	const end = new Date(endDate);

	if (now < start) return "upcoming";
	if (now > end) return "completed";
	return "underway";
}

function CardHeaderContent({ title, heading, startDate, endDate }: Props) {
	const currentStatus = calculateStatus(startDate, endDate);
	return (
		<div className="flex flex-col gap-2">
			{heading && <p className="text-muted-foreground text-sm">{heading}</p>}
			<h3 className="w-3/4 font-semibold text-lg">{title}</h3>
			<StatusBadge status={currentStatus} />
		</div>
	);
}

function CardFooterContent({ publisher, date, participants, href }: Props) {
	return (
		<div className="flex flex-col gap-2">
			<div className="flex justify-between items-center text-muted-foreground text-sm">
				<span>{publisher}</span>
				<span>{date}</span>
			</div>
			<div className="flex justify-between items-center">
				<span className="text-muted-foreground text-sm">
					{participants} participants
				</span>
				{href && (
					<a
						href={href}
						target="_blank"
						rel="noopener noreferrer"
						className="font-medium text-primary text-sm hover:underline"
					>
						Learn More
					</a>
				)}
			</div>
		</div>
	);
}

export function StudyCard(props: Props) {
	const { className, description } = props;

	return (
		<div
			className={`flex flex-col gap-4 rounded-lg border bg-card p-4 text-card-foreground shadow-sm ${
				className ?? ""
			}`}
		>
			<CardHeaderContent {...props} />
			<p className="text-muted-foreground text-sm">{description}</p>
			<CardFooterContent {...props} />
		</div>
	);
}

export default StudyCard;
